export default "__VITE_ASSET__4V9NOPuO__"